<div class="stream-tab-container">
  <div class="mat-elevation-z8">
    <mat-table #table [dataSource]="dataSource" multiTemplateDataRows="true" class="table">
      <ng-container matColumnDef="streamCir">
        <mat-header-cell *matHeaderCellDef class="header-label">
          CIR
          <div class="sub-label">Mbps</div></mat-header-cell
        >
        <mat-cell *matCellDef="let element; let i = dataIndex">
          <div class="first-row">
            <input
              matInput
              autocomplete="off"
              type="number"
              name="streamCir"
              class="width-70"
              [(ngModel)]="element.streamCir"
              [ngClass]="{ 'error-msg': checkValidation('cir', element.streamCir)?.isValid }"
              (ngModelChange)="
                checkValidation('cir', element.streamCir, element);
                onDataChange(element.streamCir, i, configMapping.CIR, element)
              "
              [matTooltip]="checkValidation('cir', element.streamCir)?.message"
              [min]="cirMinValue"
              required
            />
          </div>
          <div class="error clr-float">
            <mat-error *ngIf="checkValidation('cir', element.streamCir)?.message">{{
              checkValidation('cir', element.streamCir)?.message
            }}</mat-error>
          </div>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="streamDscp">
        <mat-header-cell *matHeaderCellDef class="header-label">
          DSCP
          <div class="sub-label">VLAN Priority</div>
        </mat-header-cell>
        <mat-cell *matCellDef="let element; let i = dataIndex" class="dscp-cell">
          <div class="width-115 first-row">
            <mat-select
              class="option-list"
              #txInterfaceInput="ngModel"
              [(ngModel)]="element.streamDscp"
              [ngClass]="{ 'error-msg': checkValidation('dscp', element.streamDscp)?.isValid }"
              name="streamDscp"
              (selectionChange)="
                checkValidation('dscp', element.streamDscp, element);
                onDataChange(element.streamDscp, i, configMapping.DSCP, element)
              "
              [matTooltip]="checkValidation('dscp', element.streamDscp)?.message"
            >
              <mat-option *ngFor="let dscp of dscpConfigTypes" [value]="dscp.id">
                {{ dscp.value }}
                ({{ dscp.id }})</mat-option
              >
            </mat-select>
          </div>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="streamTosDiffServ">
        <mat-header-cell *matHeaderCellDef class="header-label">
          Verify Received ToS/DiffServ
        </mat-header-cell>
        <mat-cell *matCellDef="let element; let i = dataIndex">
          <div class="first-row">
            <mat-select
              class="option-list width-70"
              #streamTosDiffServInput="ngModel"
              [(ngModel)]="element.streamTosDiffServ"
              [ngClass]="{
                'error-msg': checkValidation('streamTosDiffServ', element.streamTosDiffServ)
                  ?.isValid
              }"
              name="streamTosDiffServ"
              (selectionChange)="
                onDataChange(element.streamTosDiffServ, i, configMapping.TOS_DIFF_SERV, element)
              "
              required
            >
              <mat-option *ngFor="let data of tosDiffServData" [value]="data.value">{{
                data.name
              }}</mat-option>
            </mat-select>
          </div>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="streamFlowLabel">
        <mat-header-cell *matHeaderCellDef class="header-label"> Flow Label </mat-header-cell>
        <mat-cell *matCellDef="let element; let i = dataIndex">
          <div class="first-row">
            <input
              matInput
              autocomplete="off"
              type="text"
              name="streamFlowLabel"
              class="width-70"
              [(ngModel)]="element.streamFlowLabel"
              [ngClass]="{
                'error-msg': checkValidation('flowLabel', element.streamFlowLabel)?.isValid
              }"
              (ngModelChange)="
                checkValidation('flowLabel', element.streamFlowLabel, element);
                onDataChange(element.streamFlowLabel, i, configMapping.FLOW_LABEL, element)
              "
              [matTooltip]="checkValidation('flowLabel', element.streamFlowLabel)?.message"
              maxlength="5"
              required
            />
          </div>
          <div class="error clr-float">
            <mat-error *ngIf="checkValidation('flowLabel', element.streamFlowLabel)?.message">{{
              checkValidation('flowLabel', element.streamFlowLabel)?.message
            }}</mat-error>
          </div>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="streamTrafficClass">
        <mat-header-cell *matHeaderCellDef class="header-label"> Traffic Class </mat-header-cell>
        <mat-cell *matCellDef="let element; let i = dataIndex">
          <div class="first-row">
            <input
              matInput
              autocomplete="off"
              type="text"
              name="streamTrafficClass"
              class="width-50"
              [(ngModel)]="element.streamTrafficClass"
              [ngClass]="{
                'error-msg': checkValidation('trafficClass', element.streamTrafficClass)?.isValid
              }"
              (ngModelChange)="
                checkValidation('trafficClass', element.streamTrafficClass, element);
                onDataChange(element.streamTrafficClass, i, configMapping.TRAFFIC_CLASS, element)
              "
              [matTooltip]="checkValidation('trafficClass', element.streamTrafficClass)?.message"
              maxlength="2"
              required
            />
          </div>
          <div class="error clr-float">
            <mat-error
              *ngIf="checkValidation('trafficClass', element.streamTrafficClass)?.message"
              >{{ checkValidation('trafficClass', element.streamTrafficClass)?.message }}</mat-error
            >
          </div>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="streamHopLimit">
        <mat-header-cell *matHeaderCellDef class="header-label"> Hop Limit </mat-header-cell>
        <mat-cell *matCellDef="let element; let i = dataIndex">
          <div class="first-row">
            <input
              matInput
              autocomplete="off"
              type="number"
              name="streamHopLimit"
              class="width-50"
              [(ngModel)]="element.streamHopLimit"
              [ngClass]="{
                'error-msg': checkValidation('hopLimit', element.streamHopLimit)?.isValid
              }"
              (ngModelChange)="
                checkValidation('hopLimit', element.streamHopLimit, element);
                onDataChange(element.streamHopLimit, i, configMapping.HOP_LIMIT, element)
              "
              [matTooltip]="checkValidation('hopLimit', element.streamHopLimit)?.message"
              min="1"
              max="255"
              required
            />
          </div>
          <div class="error clr-float">
            <mat-error *ngIf="checkValidation('hopLimit', element.streamHopLimit)?.message">{{
              checkValidation('hopLimit', element.streamHopLimit)?.message
            }}</mat-error>
          </div>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="streamFrameSize">
        <mat-header-cell *matHeaderCellDef class="header-label"> Frames to Test </mat-header-cell>
        <mat-cell *matCellDef="let element; let i = dataIndex" class="name-cell">
          <div class="first-row">
            <input
              matInput
              autocomplete="off"
              type="text"
              name="streamFrameSize"
              class="width-280"
              [(ngModel)]="element.streamFrameSize"
              [ngClass]="{ 'error-msg': checkValidation('name', element.streamFrameSize)?.isValid }"
              (ngModelChange)="
                checkValidation('name', element.streamFrameSize, element);
                onClickFrameSize(element, i)
              "
              [matTooltip]="checkValidation('name', element.streamFrameSize)?.message"
              (click)="onClickFrameSize(element, i)"
            />
          </div>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="defaultColumns"></mat-header-row>
      <mat-row
        *matRowDef="let row; columns: defaultColumns"
        matRipple
        [ngClass]="'element-row'"
      ></mat-row>
    </mat-table>
  </div>
</div>
